import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { apiURL } from "../../../config/default";
import CircularProgress from "@mui/material/CircularProgress";
import HeadingPrimary from "../../../components/custom-heading/heading-primary";
import CustomInput from "../../../components/custom-input/custom-input";
import DropDownInput from "../../../components/drop-down-input/drop-down-input";
import CustomButton, {
  CustomButtonClasses,
  CustomButtonTypes,
} from "../../../components/custom-button/custom-button";
import { addUserFormValidationSchema } from "../../../components/form-validation-schemas/form-validation-schemas";
import { useSelector } from "react-redux";

const AddUser = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "",
    error: "",
  });
  const userRole = useSelector((state) => state?.auth?.user?.role);
  // console.log("auth", userRole)

  const option = [
    { value: "techTeam", label: "TechTeam" },
    { value: "dataTeam", label: "DataTeam" },
    { value: "customerSupport", label: "CustomerSupport" },
    { value: "callCenter", label: "CallCenter" },
    { value: "marketing", label: "Marketing" },
    { value: "sales", label: "Sales" },
  ];

  // Filter roles based on userRole
  const filteredOptions =
    userRole === "admin"
      ? option // allow all if admin
      : option.filter((opt) => opt.value === userRole); // only their role


  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setUser({
      ...user,
      [name]: value,
    });
  };

  const handleSelect = (e) => {
    if (userRole !== "admin") {
      // Force their own role only
      setUser({
        ...user,
        role: userRole,
      });
    } else {
      setUser({
        ...user,
        role: e.value,
      });
    }
  };




  const registerUser = async (user) => {
    setLoading(true);
    try {
      const res = await axios.post(`${apiURL}admin/user-register`, user);
      // toast(res?.data);
      toast.success(res?.data?.message || "User registered successfully!");
      return res;
    } catch (err) {
      // toast(err.message);
      // console.log("err",err)
      toast.error(err?.response?.data?.message || err?.data?.error || err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const resetUser = () => {
    setUser({
      error: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Additional backend protection
    const finalUserData = {
      ...user,
      role: userRole === "admin" ? user.role : userRole, // override role
    };

    try {
      await addUserFormValidationSchema.validate(finalUserData);
      registerUser(finalUserData);
      resetUser();
    } catch (error) {
      setUser({
        ...user,
        error: error?.errors?.[0],
      });
    }
  };


  return (
    <>
      <div className="page-header">
        <HeadingPrimary>Add User</HeadingPrimary>

        {/* <div>
          <Link to="/admin/paid-users">Add User</Link>&nbsp;/ View
        </div> */}
      </div>
      <ToastContainer  stacked />
      {loading ? (
        <h1>
          {
            <div className="text-center mt-5 mb-5">
              <CircularProgress valueBuffer={32} size={40} />
            </div>
          }
        </h1>
      ) : (
        <div className="row">
          <div className="col-md-12">
            <span className="text-danger">{user?.error}</span>
            <form onSubmit={handleSubmit} className="forms-sample">
              <CustomInput
                label="First Name"
                name="firstName"
                type="text"
                placeholder="First Name"
                onChange={handleChange}
                value={user.firstName}
              />

              <CustomInput
                label="Last Name"
                name="lastName"
                type="text"
                placeholder="Last Name"
                onChange={handleChange}
                value={user.lastName}
              />

              <CustomInput
                label="Phone Number"
                name="phone"
                type="number"
                placeholder="Phone Number"
                onChange={handleChange}
                value={user.phone}
              />

              <CustomInput
                label="Email"
                name="email"
                type="text"
                placeholder="email"
                onChange={handleChange}
                value={user?.email}
              />

              <CustomInput
                label="Password"
                name="password"
                type="password"
                placeholder="password"
                onChange={handleChange}
                value={user.password}
              />

              <CustomInput
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                placeholder="Confirm Password"
                onChange={handleChange}
                value={user.confirmPassword}
              />

              <DropDownInput
                label="Role"
                name="role"
                onChange={handleSelect}
                options={filteredOptions}  // ONLY show allowed roles
                value={user.role}
                placeholder="Please Select ..."
              />

              <CustomButton
                type={CustomButtonTypes.SUBMIT}
                className={CustomButtonClasses.PRIMARY}
                styles={{ marginBottom: "5px" }}
              >
                Submit
              </CustomButton>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default AddUser;
